export const ROUTES = {
  splash: '/',
  home: '/',
  about: '/about',
  faq: '/faq',
  blog: '/blog',
  pdfs: '/pdfs/',
  selectCaseStudy: '/select-case-study',

  login: '/login',
  annalyLogin: '/annaly/login',
  sso: '/sso',

  signup: '/signup',
  resetPassword: '/reset_password',
  resetPasswordApp: '/app/reset_password',
  termsOfService: '/terms-of-service',
  privacyPolicy: '/privacy-policy',
  termsOfServiceLegacy: '/terms_of_service',
  privacyPolicyLegacy: '/privacy_policy',

  forgotPasswordLegacy: '/app/forgot_password',
  forgotPassword: '/forgot-password',

  inReview: '/in-review',

  themeBuilder: '/theme-builder',

  evestmentQuery: '/evestment-query',
  rfpResponseQuery: '/rfp-response-query',
  rfpAdmin: '/rfp-response-admin',

  fedDigitalAnalyst: '/fed-digital-analyst',
  fedPublicReleaseAnalyst: '/the-fed-release-analyst',
  fedPublicSentimentAnalyst: '/the-fed-sentiment-analyst',
  fedLatestDocs: '/fed-latest-docs',

  digitalAnalyst: '/digital-analyst',
  chatDigitalAnalyst: '/chat-digital-analyst',
  rfpChatDigitalAnalyst: '/rfp-chat-digital-analyst',
  agentChatDigitalAnalyst: '/agent-chat-digital-analyst',
  researchDigitalAnalyst: '/research-digital-analyst',

  companySnapshot: '/company-snapshot',
  customSnapshot: '/custom-snapshot',

  docManagement: '/document-management',
  uploadSource: '/document-management',
  docUploadTriggers: '/document-upload-triggers',
  documentVault: '/document-vault',

  factor: '/factor',
  factorVisual: '/factor-visual',

  screener: '/screener',
  researchScreener: '/research-screener',

  growthEquityAnalysis: '/growth-equity-analysis',

  latestUpdates: '/latest-updates',
  latestEarningsUpdates: '/earnings-latest-updates',

  lenderEarningsUpdates: '/lender-earnings-analysis',

  stock: '/stock',
  securityDetail: '/security-detail',
  tagDetail: '/tag-detail',

  agentResult: '/agent-result',

  docViewer: '/view-document',
  docSummary: '/view-summary',

  compliance: '/compliance',
  queryHistory: '/query-history',

  docProcessingToDA: '/await-doc-processing',
  warningIndicators: '/warning-indicators',
  bullBearCases: '/bull-bear-cases',

  citations: '/citations',
  esgUpdates: '/esg-updates',

  newDealTriage: '/test-new-deal-triage',
  growthEquityMemo: '/test-growth-equity-memo-template',

  website: '/website-digital-analyst',
  webpageIngestion: '/website-summary',

  evaluationTemplate: '/eval-template',

  macroEconomicSignals: '/macro-economic-signals',
  economicImpact: '/economic-impact',

  textSearch: '/text-search',
  accountSettings: '/account-settings',
  watchlist: '/watchlist',

  liquidityTermsTableAnalysis: '/liquidity-terms-analysis',
  ppmTableAnalysis: '/ppm-analysis',
  tableAnalysis: '/table-analysis',
  creditAgreementAnalysis: '/credit-agreement-analysis',

  quarterlyDataTemplate: '/quarterly-data-template',
  earningsGridTemplate: '/earnings-grid-template',
  docGridAgent: '/doc-grid-agent',

  queryFlow: '/query-flow',
  reasoningQuery: '/reasoning-query',
  querySeries: '/query-series',
  dataAnalystAgent: '/data-analyst-agent',
  scoreBackfill: '/score-backfill',
  scoreBackfillHistory: '/score-backfill/history',
  scoreBackfillJobs: '/score-backfill/jobs',
  scoreSpec: '/advanced-score-spec',
  scoreSpecSpecs: '/advanced-score-spec/specs',
  // The backend's permissioned_modes still advertises the pre-rename path. Kept so Router can
  // redirect it (and any bookmarked link) onto the advanced- prefixed route above.
  legacyScoreSpec: '/score-spec',
  // The simple mode. A separate page from the advanced editor above rather than a route inside it —
  // it owns no sub-routes and shares no state with the editor, only the score_spec_admin grant.
  //
  // Named for what an operator comes here to DO. The mechanism underneath is duplication, and it has
  // to be: an approved spec is frozen and there is no unlock endpoint, so editing one means authoring
  // its successor. No legacy redirect is needed — this path has never shipped, so there is nothing
  // bookmarked and nothing in permissioned_modes pointing at the old spelling (unlike the
  // /score-spec -> /advanced-score-spec rename above, which did need one).
  //
  // Takes an optional `/:specId` (see Router): the fetch screen sends a record it has already read,
  // and the form opens with that spec picked. The bare path still opens on an unanswered picker.
  editScoreSpec: '/edit-score-spec',
  // The thinnest modes: one textarea holding the request body sent as typed, and its read counterpart.
  // Same grant as the editors above.
  createScoreSpec: '/create-score-spec',
  // The read mode takes an optional `/:specId` (see Router) — the advanced list opens a clicked row
  // there, so the record shows up without the picker being answered a second time. The bare path
  // still works and is what the list's own "Fetch a spec by id" button uses.
  getScoreSpec: '/get-score-spec',
  feedView: '/feed-view',
  // Financial model data capture (fmdc). One splat route; the page owns the nested views below it
  // (runs/:runId, runs/:runId/review, catalog, audit, settings), the ScoreBackfill shape. The
  // sub-path constants exist so links from one view to another never spell the segments twice.
  fmdc: '/model-data-capture',
  fmdcRuns: '/model-data-capture/runs',
  fmdcCatalog: '/model-data-capture/catalog',
  fmdcAudit: '/model-data-capture/audit',
  fmdcSettings: '/model-data-capture/settings',

  quickLook: '/quick-look',
  legacyQuickLook: '/quick-look-legacy',

  investmentMemo: '/investment-memo-template',

  clientMatrix: '/client-matrix-questions',
  clientPeerMatrix: '/peer-analysis-matrix-questions',
  clientQuery: '/client-ask-digital-analyst',

  peerBenchmarking: '/peer-benchmarking-template',

  agentScriptEditor: '/agent-script-editor',
  agentScriptGenerator: '/agent-script-generator',
  queryAgentScript: '/query-agent-script',

  flowAgentScriptEditor: '/flow-agent-script-editor',
  portfolioMonitoringTemplate: '/portfolio-monitoring-template',

  templateRedownload: '/template-redownload',
  filledTemplateDownload: '/filled-template-download',

  agentSpreadsheet: '/agent-spreadsheet',
  agentMemoryAdmin: '/agent-memory-admin',
  tableBuilderTool: '/table-builder-tool',

  ddqTemplate: '/ddq-template',
  documentTemplateProcessor: '/document-template-processor',

  brokerageAccount: '/brokerage-account',
  brokerageTaxDocuments: '/brokerage-documents',
};
